<app-header-top class="d-block w-100 pl-20 pr-20 bg-white pr-sm-0 pl-sm-0"></app-header-top>
<header-nav *ngIf="!routeService.isUserPage" class="d-block w-100"></header-nav>
<retailer-store-header-nav *ngIf="routeService.isUserPage && isRetailer" class="d-block w-100 mat-elevation-z1">
</retailer-store-header-nav>
<consumer-header-nav *ngIf="routeService.isUserPage && !isRetailer" class="d-block w-100 mat-elevation-z1">
</consumer-header-nav>